import { Button } from "@/components/ui/button";
import { Camera, FileText, MapPin } from "lucide-react";
import { trackEstimate } from "@/lib/track";

const STEPS = [
  {
    n: "01",
    icon: Camera,
    title: "Send Photos & Videos",
    text: "Send us photos or videos of your property and tell us what you want to renovate.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Get a Rough Estimate",
    text: "We review the available information and provide a preliminary budget indication.",
  },
  {
    n: "03",
    icon: MapPin,
    title: "Free Site Inspection",
    text: "Our team visits the property, assesses the actual condition and requirements, and prepares the detailed quotation.",
  },
];

export default function Conversion() {
  return (
    <section
      id="conversion"
      data-testid="conversion-section"
      className="py-20 lg:py-28 bg-[#F9F8F6]"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12 lg:mb-16 max-w-3xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            How It Works
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 mb-4 leading-[1.1]">
            Planning to Renovate Your Apartment or Home in Dubai?
          </h2>
          <p className="font-heading text-xl lg:text-2xl text-[#A88746] font-medium mb-4">
            Start With Your Photos.
          </p>
          <p className="text-base lg:text-lg text-neutral-600 leading-relaxed">
            Photos and videos give you a <strong className="font-semibold text-neutral-800">rough estimate</strong>. The <strong className="font-semibold text-neutral-800">actual price</strong> is confirmed after a free site inspection and detailed scope assessment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6 mb-10">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`conversion-step-${s.n}`}
              className="relative bg-neutral-950 text-white border border-neutral-800 p-8 lg:p-9 overflow-hidden hover:border-[#C5A059] transition-colors duration-300 group"
            >
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#C5A059]/10 blur-[60px] pointer-events-none" />
              <div className="relative">
                <div className="flex items-start justify-between mb-6">
                  <span className="font-heading text-5xl font-light text-[#C5A059] group-hover:text-[#E2C988] transition-colors duration-300">
                    {s.n}
                  </span>
                  <div className="w-12 h-12 border border-[#C5A059]/40 bg-[#C5A059]/10 flex items-center justify-center group-hover:border-[#C5A059] transition-colors duration-300">
                    <s.icon className="w-6 h-6 text-[#C5A059]" strokeWidth={1.5} />
                  </div>
                </div>
                <div className="h-px w-10 bg-[#C5A059] mb-4" />
                <h3 className="font-heading text-xl font-medium text-white leading-snug mb-2.5">
                  {s.title}
                </h3>
                <p className="text-[15px] text-neutral-300 leading-relaxed">{s.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a href="#lead-form" data-testid="conversion-cta" onClick={() => trackEstimate("conversion_section")}>
            <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-8 py-7 text-base font-semibold tracking-wide">
              GET MY ROUGH RENOVATION ESTIMATE
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
